(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		//this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);
  if (!window.sateliteCartQuickAddInstalled) {
    window.sateliteCartQuickAddInstalled = true;
    let sateliteBannerFrame = null;
    function updateSateliteMobileBanner() {
      sateliteBannerFrame = null;
      document.querySelectorAll('.satelite-mobile-checkout').forEach(function(banner) {
        const cartSection = banner.closest('.main-cart');
        const marker = cartSection && (cartSection.querySelector('.satelite-cart-note summary') || cartSection.querySelector('.cart__ctas'));
        const footer = banner.closest('#main-cart-footer');
        const visible = window.matchMedia('(max-width: 989px)').matches && marker && footer && !footer.classList.contains('is-empty') && marker.getBoundingClientRect().bottom <= 0;
        banner.classList.toggle('is-scroll-visible', Boolean(visible));
      });
    }
    function scheduleSateliteMobileBanner() {
      if (sateliteBannerFrame === null) sateliteBannerFrame = window.requestAnimationFrame(updateSateliteMobileBanner);
    }
    document.addEventListener('scroll', scheduleSateliteMobileBanner, { passive: true, capture: true });
    window.addEventListener('resize', scheduleSateliteMobileBanner, { passive: true });
    window.addEventListener('pageshow', scheduleSateliteMobileBanner);
    document.addEventListener('cart:change', scheduleSateliteMobileBanner);
    document.addEventListener('satelite:cart-rendered', scheduleSateliteMobileBanner);
    document.addEventListener('shopify:section:load', scheduleSateliteMobileBanner);
    scheduleSateliteMobileBanner();
    document.addEventListener('cart:change', function(event) {
      if (!event.detail || !event.detail.cart) return;
      const count = event.detail.cart.item_count;
      document.querySelectorAll('[data-satelite-mobile-count]').forEach(function(label) {
        label.textContent = count + ' ' + (count === 1 ? label.dataset.singular : label.dataset.plural);
      });
    });
    document.addEventListener('change', function(event) {
      if (event.target.matches('[data-satelite-quick-variant]')) event.stopPropagation();
    }, true);
    document.addEventListener('click', async function(event) {
      const button = event.target.closest('[data-satelite-quick-add]');
      if (!button) return;
      event.preventDefault();
      if (window.sateliteCartQuickAddBusy) return;
      window.sateliteCartQuickAddBusy = true;
      const card = button.closest('[data-satelite-quick-card]');
      const message = card.querySelector('.satelite-quick-message');
      const selector = card.querySelector('[data-satelite-quick-variant]');
      const variantId = selector ? selector.value : button.dataset.variant;
      const sectionId = button.dataset.section;
      const sectionElement = document.getElementById('shopify-section-' + sectionId);
      const oldNote = sectionElement && sectionElement.querySelector('#Cart-note');
      const pendingNote = oldNote ? oldNote.value : null;
      const oldDetails = sectionElement && sectionElement.querySelector('.satelite-cart-note');
      const noteWasOpen = oldDetails && oldDetails.open;
      let added = false;
      document.querySelectorAll('[data-satelite-quick-add]').forEach(function(item) { item.disabled = true; });
      button.textContent = button.dataset.loading;
      message.textContent = '';
      try {
        const response = await fetch(button.dataset.url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: [sectionId, 'cart-icon-bubble'], sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'No se pudo agregar. Inténtalo de nuevo.');
        added = true;
        const sectionHtml = result.sections && result.sections[sectionId];
        if (!sectionHtml || !sectionElement) throw new Error('La bolsa se agregó, pero no se pudo actualizar la vista. Actualiza esta página para verla.');
        const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const updatedSection = parsed.getElementById('shopify-section-' + sectionId);
        if (!updatedSection) throw new Error('La bolsa se agregó. Actualiza esta página para verla.');
        sectionElement.innerHTML = updatedSection.innerHTML;
        const newNote = sectionElement.querySelector('#Cart-note');
        if (newNote && pendingNote !== null) newNote.value = pendingNote;
        const newDetails = sectionElement.querySelector('.satelite-cart-note');
        if (newDetails && noteWasOpen) newDetails.open = true;
        const bubbleHtml = result.sections['cart-icon-bubble'];
        if (bubbleHtml) {
          const bubbleDocument = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          const currentBubble = document.getElementById('cart-icon-bubble');
          const nextBubble = bubbleDocument.getElementById('cart-icon-bubble') || bubbleDocument.querySelector('.shopify-section');
          if (currentBubble && nextBubble) currentBubble.innerHTML = nextBubble.innerHTML;
        }
        const notice = document.createElement('p');
        notice.className = 'satelite-quick-message';
        notice.setAttribute('role', 'status');
        notice.setAttribute('aria-live', 'polite');
        notice.textContent = button.dataset.success;
        const heading = sectionElement.querySelector('.satelite-cart-heading');
        if (heading) heading.insertAdjacentElement('afterend', notice);
        document.dispatchEvent(new CustomEvent('satelite:cart-rendered'));
      } catch (error) {
        message.textContent = added ? 'La bolsa ya se agregó. Actualiza la página para verla; no vuelvas a agregarla.' : error.message;
      } finally {
        window.sateliteCartQuickAddBusy = false;
        document.querySelectorAll('[data-satelite-quick-add]').forEach(function(item) { item.disabled = false; });
        if (button.isConnected) {
          button.textContent = button.dataset.label;
          if (added) button.disabled = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();

		this.isProductPage = true
	}

	hide() {
		super.hide(this.isProductPage);
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();		
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
		}
		if (activeMedia?.nodeName == 'DEFERRED-MEDIA' && activeMedia?.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();
})();
